export default __webpack_public_path__ + "static/media/post.65c02bb8.png";